module.exports = __webpack_public_path__ + "img/login_logo1.03028a43.png";